<template>
  <div>
    <div v-if="legend">
      <br/>

      <p>{{ legend }}</p>

      <br/>
    </div>

    <div
        class="knob-control"
        id="knobControlContainer"
        :style="{ height: size - 5 + 'px' }"
    >
      <svg
          :width="size"
          :height="size"
          viewBox="0 0 100 100"
          id="knobControl"
          @click="onClick"
          @mousedown="onMouseDown"
          @mouseup="onMouseUp"
      >
        <path
            :d="rangePath"
            :stroke-width="strokeWidth"
            :stroke="secondaryColor"
            class="knob-control__range clickable"
        ></path>
        <path
            :d="linePath"
            :stroke-width="lineWidth"
            :stroke="primaryColor"
            class="knob-control__range clickable"
        ></path>

        <circle
            v-if="showValue && showCircle"
            :fill="primaryColor"
            :cx="circlePositionX"
            :cy="circlePositionY"
            r="2.5"
        />

        <path
            v-for="tick in ticksNumber + 1"
            :key="tick"
            :d="tickPath(tick - 1)"
            :stroke-width="0.5"
            :stroke="primaryColor"
            class="knob-control__range clickable"
        ></path>

        <path
            @click="incrementValue"
            :d="plusButtonPath"
            :stroke-width="strokeWidth"
            :stroke="secondaryColor"
            class="knob-control__range"
        ></path>

        <path
            @click="decrementValue"
            :d="minusButtonPath"
            :stroke-width="strokeWidth"
            :stroke="secondaryColor"
            class="knob-control__range"
        ></path>

        <text
            @click="decrementValue"
            :x="41"
            :y="93"
            text-anchor="middle"
            class="clickable"
            :fill="primaryColor"
        >
          -
        </text>
        <text
            @click="incrementValue"
            :x="59"
            :y="92"
            text-anchor="middle"
            font-size="10"
            class="clickable"
            :fill="primaryColor"
        >
          +
        </text>
      </svg>
      <div class="data">
        <div class="dataUpper">
          <div v-if="type === 'device' && !isFloor">
            <!--            <span v-if="icons.windowsOpenMode">-->
            <!--              <img-->
            <!--                v-if="data.windows_open_mode"-->
            <!--                src="/home/images/thermostat/icn_ventanas_abiertas.png"-->
            <!--              />-->
            <!--              <img-->
            <!--                v-else-->
            <!--                src="/home/images/thermostat/icn_ventanas_abiertas_off.png"-->
            <!--              />-->
            <!--            </span>-->
            <lottie
                v-if="data.status_warming === 1"
                :options="fuzzyResistanceActive"
                :animCreated="handleAnimation"
                :styles="{
                'border-radius': '50px',
                'background-color': 'white',
                height: '25px',
                width: '25px',
                overflow: 'hidden',
                padding: '3px',
                position: 'absolute',
                top: '-65px',
                right: '-65px',
              }"
            />

            <lottie
                v-if="data.status_warming === 2"
                :options="fuzzyLogicActive"
                :animCreated="handleAnimation"
                :styles="{
                'border-radius': '50px',
                'background-color': 'white',
                height: '25px',
                width: '25px',
                overflow: 'hidden',
                padding: '3px',
                position: 'absolute',
                top: '-65px',
                right: '-65px',
              }"
            />
            <span v-if="icons.pirMode">
              <img
                  v-if="data.pir_mode"
                  src="/home/images/thermostat/modo_presencia_on.png"
              />
              <img
                  v-else
                  src="/home/images/thermostat/modo_presencia_off.png"
              />
            </span>

            <!--            <span v-if="icons.block">-->
            <!--              <img-->
            <!--                v-if="data.block_remote"-->
            <!--                src="/home/images/thermostat/modo_bloqueo_remoto_on.png"-->
            <!--              />-->
            <!--              <img-->
            <!--                v-else-if="data.block_local"-->
            <!--                src="/home/images/thermostat/modo_bloqueo_remoto_teclado_on.png"-->
            <!--              />-->
            <!--              <img-->
            <!--                v-else-->
            <!--                src="/home/images/thermostat/modo_bloqueo_remoto_teclado_off.png"-->
            <!--              />-->
            <!--            </span>-->

            <span v-if="icons.pilotMode">
              <img
                  v-if="data.pilot_mode"
                  src="/home/images/thermostat/modo_p_on.png"
              />
              <img v-else src="/home/images/thermostat/modo_p_off.png"/>
            </span>

            <span v-if="icons.userMode">
              <img
                  v-if="data.user_mode"
                  src="/home/images/thermostat/modo_u_on.png"
              />
              <img v-else src="/home/images/thermostat/modo_u_off.png"/>
            </span>
          </div>
          <div v-if="type === 'zone' && !isFloor">
            <span v-if="data.type !== 'acs'">
              <!--              <img-->
              <!--                v-if="data.windows_open_mode"-->
              <!--                src="/home/images/thermostat/icn_ventanas_abiertas.png"-->
              <!--              />-->
              <!--              <img-->
              <!--                v-else-->
              <!--                src="/home/images/thermostat/icn_ventanas_abiertas_off.png"-->
              <!--              />-->

              <img
                  v-if="data.pir_mode"
                  src="/home/images/thermostat/modo_presencia_on.png"
              />
              <img
                  v-else
                  src="/home/images/thermostat/modo_presencia_off.png"
              />
            </span>

            <img
                v-if="data.pilot_mode"
                src="/home/images/thermostat/modo_p_on.png"
            />
            <img v-else src="/home/images/thermostat/modo_p_off.png"/>
          </div>
        </div>

        <div class="dataMiddle">
          <div v-if="data.power && showValue" class="zone-temp">
            <div v-if="mode">
              <div v-if="autoMode === 'O'">
                <h2 v-if="inconsistent">-</h2>
                <div v-else-if="!iceMode">
                  {{ $t("thermostat.off") }}
                  <span class="scale-decimal"></span>
                </div>
                <div v-else>
                  {{ Math.floor(autoTemp) }}
                  <span class="scale-decimal"
                  >º
                    <span v-if="!isInt(autoTemp)" class="decimal">.5</span>
                  </span>
                </div>
              </div>
              <div v-else>
                {{ Math.floor(autoTemp) }}
                <span class="scale-decimal"
                >º
                  <span v-if="!isInt(autoTemp)" class="decimal">.5</span>
                </span>
              </div>
            </div>

            <div v-else-if="inconsistent">-</div>

            <div v-else>
              {{ Math.floor(valueDisplay) }}
              <span class="scale-decimal"
              >º
                <span v-if="!isInt(valueDisplay)" class="decimal">.5</span>
              </span>
            </div>
          </div>
          <div class="zone-temp" v-else-if="!data.power">
            <div>
              {{ $t("thermostat.off") }}
              <span class="scale-decimal"></span>
            </div>
          </div>
          <span class="zone-temp-off" v-else>-</span>
        </div>

        <div class="dataLower" v-if="type !== 'container'">
          <div style="margin: -10px 0 10px 0">
            <p class="meters" v-if="data.meters">{{ data.meters }} m2</p>
            <div
                v-else-if="data.temp_probe"
                style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <div
                  style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img :src="imageIconName" style="width: 20px"/>
              </div>
              <div>
                <label class="meters">{{ data.temp_probe }} ºC</label>
              </div>
            </div>
          </div>

          <ManualAuto
              v-if="!isFloor"
              v-model="mode"
              :key="valueDisplay + power"
          />
        </div>

        <div class="dataLower" v-if="type === 'container'">
          <ManualAuto v-model="mode" :key="valueDisplay + power"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ManualAuto from "@/components/switch/ManualAuto";

const RADIUS = 40;
const MID_X = 50;
const MID_Y = 50;
const MIN_RADIANS = (4 * Math.PI) / 3;
const MAX_RADIANS = -Math.PI / 3;

import zapp from "@/util/zapp";
import constants from "@/config/constants";
import * as LogicActive from "../../../public/Fuzzy_logic_activo_Lottie.json";
import * as ResistanceActive from "../../../public/resistencia_activa_lottie.json";
import Lottie from "@/components/Lottie/Lottie";

// map a value (x) from one range (in min/max) onto another (out min/max)
const mapRange = (x, inMin, inMax, outMin, outMax) => {
  return ((x - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
};

export default {
  components: {ManualAuto, Lottie},
  data() {
    return {
      fuzzyLogicActive: {animationData: LogicActive},
      fuzzyResistanceActive: {animationData: ResistanceActive},
      animationSpeed: 1,
      temp: this.value,
      mode: this.auto,
    };
  },
  name: "knob-control",
  props: {
    inconsistent: {
      required: false,
      default: false,
    },

    legend: {
      required: false,
      default: null,
    },

    value: {
      required: true,
    },
    max: {
      type: Number,
      default: 100,
    },
    min: {
      type: Number,
      default: 0,
    },
    stepSize: {
      type: Number,
      default: 0.5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 350,
    },
    primaryColor: {
      type: String,
      default: "#fff",
    },
    secondaryColor: {
      type: String,
      default: "rgba(255, 255, 255, 0.25)",
    },

    strokeWidth: {
      type: Number,
      default: 12,
    },
    lineWidth: {
      type: Number,
      default: 0.35,
    },
    valueDisplayFunction: {
      type: Function,
      default: (v) => v,
    },
    auto: {
      validator: (prop) => typeof prop === "boolean" || prop === null,
      required: false,
    },
    data: {
      type: Object,
      required: false,
    },
    ticksNumber: {
      type: Number,
      default: 40,
    },
    type: {
      type: String,
      default: "device",
    },
    isFloor: {
      type: Boolean,
      default: false,
    },
    autoMode: {
      type: String,
      required: false,
      default: "E",
    },
    autoTemp: {
      type: Number,
      required: false,
      default: 25,
    },

    iceMode: {
      type: Boolean,
      required: false,
      default: false,
    },

    power: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    icons() {
      return constants.iconOptions[this.data.type];
    },

    rangePath() {
      return `M ${this.minX + 2} ${this.minY + 1} A ${RADIUS} ${RADIUS} 0 1 1 ${
          this.maxX - 2
      } ${this.maxY + 1}`;
    },
    linePath() {
      return `M ${this.minX} ${this.minY} A ${RADIUS} ${RADIUS} 0 1 1 ${this.maxX} ${this.maxY}`;
    },
    valuePath() {
      return `M ${this.zeroX} ${this.zeroY} A ${RADIUS} ${RADIUS} 0 ${this.largeArc} ${this.sweep} ${this.valueX} ${this.valueY}`;
    },
    plusButtonPath() {
      return `M ${MID_X + 0.5} ${this.zeroY + 5.5} A ${RADIUS - 5} ${
          RADIUS - 5
      } 0 0 0 ${this.maxX - 3} ${this.maxY + 1.5}`;
    },
    minusButtonPath() {
      return `M ${this.minX + 3} ${this.minY + 1.5} A ${RADIUS - 5} ${
          RADIUS - 5
      } 0 0 0 ${MID_X - 0.5} ${this.zeroY + 5.5}`;
    },

    circlePositionX() {
      return this.valueX;
    },
    circlePositionY() {
      return this.valueY;
    },
    showValue() {
      return this.temp >= this.min && this.temp <= this.max && !this.disabled;
    },
    zeroRadians() {
      /* this weird little bit of logic below is to handle the fact that usually we
                    want the value arc to start drawing from the 'zero' point, but, in the case
                    that the minimum and maximum values are both above zero, we set the 'zero point'
                    at the supplied minimum, so the value arc renders as the user would expect */
      if (this.min > 0 && this.max > 0)
        return mapRange(this.min, this.min, this.max, MIN_RADIANS, MAX_RADIANS);
      else return mapRange(2, this.min, this.max, MIN_RADIANS, MAX_RADIANS);
    },

    showCircle() {
      if (!this.power) return false;

      return !(this.mode && this.autoMode === "O" && !this.iceMode);
    },

    valueRadians() {
      if (this.mode) {
        return mapRange(
            this.autoTemp,
            this.min,
            this.max,
            MIN_RADIANS,
            MAX_RADIANS
        );
      } else
        return mapRange(
            this.temp,
            this.min,
            this.max,
            MIN_RADIANS,
            MAX_RADIANS
        );
    },
    minX() {
      return MID_X + Math.cos(MIN_RADIANS) * RADIUS;
    },
    minY() {
      return MID_Y - Math.sin(MIN_RADIANS) * RADIUS;
    },
    maxX() {
      return MID_X + Math.cos(MAX_RADIANS) * RADIUS;
    },
    maxY() {
      return MID_Y - Math.sin(MAX_RADIANS) * RADIUS;
    },
    zeroX() {
      return MID_X + Math.cos(this.zeroRadians) * RADIUS;
    },
    zeroY() {
      return MID_Y - Math.sin(this.zeroRadians) * RADIUS;
    },
    valueX() {
      return MID_X + Math.cos(this.valueRadians) * RADIUS;
    },
    valueY() {
      return MID_Y - Math.sin(this.valueRadians) * RADIUS;
    },
    largeArc() {
      return Math.abs(this.zeroRadians - this.valueRadians) < Math.PI ? 0 : 1;
    },
    sweep() {
      return this.valueRadians > this.zeroRadians ? 0 : 1;
    },
    valueDisplay() {
      return this.valueDisplayFunction(this.temp);
    },
    imageIconName() {
      switch (this.data.type) {
        case constants.deviceTypes.radiator:
        case constants.deviceTypes.radiatorb:
        case constants.deviceTypes.oval_towel:
        case constants.deviceTypes.towel:
        case constants.deviceTypes.therm:
        case constants.deviceTypes.floor:
          return "/home/images/thermostat/modo_casa_on.png";

        case constants.deviceTypes.acs:
        default:
          return "/home/images/thermostat/modo_calentador_on.png";
      }
    },
  },
  methods: {
    tickPath(tick) {
      var range = mapRange(tick, 0, this.ticksNumber, MIN_RADIANS, MAX_RADIANS);

      var x1 = MID_X + Math.cos(range) * (RADIUS + 4);
      var y1 = MID_Y - Math.sin(range) * (RADIUS + 4);
      var x2 = MID_X + Math.cos(range) * (RADIUS + 5.5);
      var y2 = MID_Y - Math.sin(range) * (RADIUS + 5.5);

      return `M ${x1} ${y1} L ${x2} ${y2}`;
    },
    calculatePosition(e) {
      let container = document.getElementById("knobControl");
      let rect = container.getBoundingClientRect();

      return {x: e.clientX - rect.left, y: e.clientY - rect.top};
    },
    updatePosition(e) {
      let offset = this.calculatePosition(e);

      const dx = offset.x - this.size / 2;
      const dy = this.size / 2 - offset.y;
      const angle = Math.atan2(dy, dx);
      let v;
      /* bit of weird looking logic to map the angles returned by Math.atan2() onto
                    our own unconventional coordinate system */
      const start = -Math.PI / 2 - Math.PI / 6;
      if (angle > MAX_RADIANS) {
        v = mapRange(angle, MIN_RADIANS, MAX_RADIANS, this.min, this.max);
      } else if (angle < start) {
        v = mapRange(
            angle + 2 * Math.PI,
            MIN_RADIANS,
            MAX_RADIANS,
            this.min,
            this.max
        );
      } else {
        return;
      }
      this.temp =
          Math.round((v - this.min) / this.stepSize) * this.stepSize + this.min;
    },
    onClick(e) {
      if (!this.disabled) {
        this.updatePosition(e);
      }
    },
    onMouseDown(e) {
      if (!this.disabled) {
        e.preventDefault();
        window.addEventListener("mousemove", this.onMouseMove);
        window.addEventListener("mouseup", this.onMouseUp);
      }
    },
    onMouseUp(e) {
      if (!this.disabled) {
        e.preventDefault();
        window.removeEventListener("mousemove", this.onMouseMove);
        window.removeEventListener("mouseup", this.onMouseUp);
      }
    },
    onMouseMove(e) {
      if (!this.disabled) {
        e.preventDefault();
        this.updatePosition(e);
      }
    },
    incrementValue() {
      if (
          !this.disabled &&
          this.temp + this.stepSize <= this.max &&
          this.temp >= this.min
      ) {
        this.temp += this.stepSize;
      }
    },
    decrementValue() {
      if (
          !this.disabled &&
          this.temp - this.stepSize >= this.min &&
          this.temp <= this.max
      ) {
        this.temp -= this.stepSize;
      }
    },
    isInt: (n) => zapp.isInt(n),

    handleAnimation: function (anim) {
      this.anim = anim;
    },
  },
  watch: {
    value: function () {
      this.temp = this.value;
    },
    auto: function () {
      this.mode = this.auto;
    },
    mode: function () {
      this.$emit("toggle-mode", this.mode);
    },
    temp: function (newValue) {
      if (this.autoTemp === this.value && this.value === newValue && this.auto) {
        return false;
      } else {
        if (this.type !== "container") this.mode = false;
        this.$emit("update-temp", this.temp);
      }
    }
  },
};
</script>

<style lang="scss">
.knob-control__range {
  fill: none;
  cursor: pointer;
  transition: stroke 0.1s ease-in;
}

.knob-control__value {
  fill: none;
}

.knob-control {
  .data {
    position: relative;
    bottom: 275px;
    width: 185px;
    margin: 0 auto;
  }

  .dataUpper {
    min-height: 2rem;
  }

  .dataUpper img {
    width: 18%;
    padding: 2%;
    display: inline;
  }

  .dataLower {
    margin-top: 5%;
  }

  .zone-temp {
    font-size: 3.5rem;
    margin-top: 0.5rem;
    font-weight: bold;
    line-height: 3.5rem;
  }

  .zone-temp .decimal {
    position: absolute;
    font-size: 1.6rem;
    left: -0.5rem;
    top: 1rem;
  }

  .zone-temp .scale-decimal {
    position: relative;
    font-size: 2.2rem;
    margin-left: -0.5rem;
    top: -1.2rem;
  }

  .switchLabel {
    font-weight: bold;
    margin-right: 0.4rem;
    padding-bottom: 0.4rem;
  }

  .meters {
    font-size: 0.85rem;
    margin-left: 7px;
  }
}
</style>
